import React, { useEffect, useState } from "react";
import InputMask from "react-input-mask";
import { Save } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { listarDistribuidoresDropdown } from "../services/api";
import PermissoesUsuario, { flagsPadrao } from "./PermissoesUsuario";

const inputClass = "w-full px-3 py-2.5 rounded-xl border zen-card dark:bg-slate-950/40 dark:border-white/10 dark:text-white";
const labelClass = "block text-sm font-medium mb-1 dark:text-slate-200";

const CadastroDistribuidorUsuario = ({
  token,
  initialData = {},
  onSubmit,
  isEdit = false,
  distribuidorIdFromQuery = "",
}) => {
  const navigate = useNavigate();
  const [distribuidores, setDistribuidores] = useState([]);
  const [permissoes, setPermissoes] = useState(flagsPadrao("distribuidor"));
  const [usuario, setUsuario] = useState({
    distribuidorId: distribuidorIdFromQuery ? Number(distribuidorIdFromQuery) : 0,
    nome: "",
    telefone: "",
    email: "",
    senha: "",
    ativo: true,
  });

  useEffect(() => {
    listarDistribuidoresDropdown(token)
      .then((r) => setDistribuidores(Array.isArray(r.data) ? r.data : []))
      .catch(() => setDistribuidores([]));
  }, [token]);

  useEffect(() => {
    if (!initialData || !Object.keys(initialData).length) return;
    setUsuario({
      distribuidorId: Number(initialData.distribuidorId || distribuidorIdFromQuery || 0),
      nome: initialData.nome || "",
      telefone: initialData.telefone || "",
      email: initialData.email || "",
      senha: "",
      ativo: initialData.ativo !== false,
    });
    const salvas = initialData.permissoes || [];
    setPermissoes(salvas.length ? salvas : flagsPadrao("distribuidor"));
  }, [initialData, distribuidorIdFromQuery]);

  const set = (name) => (e) => {
    const value = name === "distribuidorId" ? Number(e.target.value) : e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setUsuario((prev) => ({ ...prev, [name]: value }));
  };

  const salvar = async (e) => {
    e.preventDefault();
    if (!usuario.distribuidorId) {
      alert("Selecione o distribuidor.");
      return;
    }
    if (!isEdit && !usuario.senha) {
      alert("Senha é obrigatória no cadastro.");
      return;
    }
    try {
      await onSubmit({
        distribuidorId: Number(usuario.distribuidorId),
        nome: usuario.nome,
        telefone: usuario.telefone,
        email: usuario.email,
        senha: usuario.senha,
        ativo: Boolean(usuario.ativo),
        permissoes,
      }, token);
      alert(isEdit ? "Usuário atualizado com sucesso!" : "Usuário cadastrado com sucesso!");
      navigate(`/distribuidores/usuarios?distribuidorId=${usuario.distribuidorId}`);
    } catch (err) {
      const data = err?.response?.data;
      alert(typeof data === "string" ? data : data?.message || "Erro ao salvar usuário.");
    }
  };

  return (
    <div className="max-w-3xl mx-auto zen-card rounded-2xl p-6 md:p-8">
      <h2 className="text-2xl font-bold mb-6 dark:text-white">{isEdit ? "Editar Usuário do Distribuidor" : "Cadastro de Usuário do Distribuidor"}</h2>
      <form onSubmit={salvar} className="space-y-4">
        <div>
          <label className={labelClass}>Distribuidor</label>
          <select className={inputClass} value={usuario.distribuidorId || ""} onChange={set("distribuidorId")} required>
            <option value="">Selecione</option>
            {distribuidores.map((d) => (
              <option key={d.id} value={d.id}>{d.nomeFantasia || d.razaoSocial}</option>
            ))}
          </select>
        </div>
        <div>
          <label className={labelClass}>Nome</label>
          <input className={inputClass} value={usuario.nome} onChange={set("nome")} required />
        </div>
        <div>
          <label className={labelClass}>Telefone</label>
          <InputMask mask="(99) 99999-9999" className={inputClass} value={usuario.telefone} onChange={set("telefone")} />
        </div>
        <div>
          <label className={labelClass}>Email</label>
          <input type="email" className={inputClass} value={usuario.email} onChange={set("email")} required />
        </div>
        <div>
          <label className={labelClass}>{isEdit ? "Nova senha (deixe em branco para não alterar)" : "Senha"}</label>
          <input type="password" className={inputClass} value={usuario.senha} onChange={set("senha")} required={!isEdit} />
        </div>
        <label className="inline-flex items-center gap-2 text-sm">
          <input type="checkbox" checked={!!usuario.ativo} onChange={set("ativo")} /> Usuário ativo
        </label>
        <PermissoesUsuario audiencia="distribuidor" value={permissoes} onChange={setPermissoes} />
        <div className="flex justify-end">
          <button className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-blue-600 text-white font-semibold text-sm">
            <Save size={18} /> {isEdit ? "Salvar Alterações" : "Cadastrar Usuário"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CadastroDistribuidorUsuario;
